<template>
  <el-dialog
    class="add-ca-service-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="名称" prop="Name">
        <el-input v-model="editForm.Name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="国家" prop="Country">
        <el-input v-model="editForm.Country" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="省份" prop="Province">
        <el-input v-model="editForm.Province" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="地区" prop="Locality">
        <el-input v-model="editForm.Locality" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="地址" prop="Addr">
        <el-input v-model="editForm.Addr" placeholder="格式:192.168.1.1:90"></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="Username">
        <el-input v-model="editForm.Username" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="Password">
        <el-input v-model="editForm.Password" type="password" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'InitRoot', 
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  data() {
    let validateAddr = (rule, value, callback) => {
      let reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}((2[0-4]\d|25[0-5]|[01]?\d\d?)\:)(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[0-5]\d{4}|[1-9]\d{0,3})$/
      if (value === '') {
        callback(new Error('请输入地址'))
      } else if (!reg.test(value)) {
        callback(new Error('地址格式不正确'))
      } else {
        callback()
      }
    }
    return {
      title: '添加CA服务',
      dialogVisible: false,
      disabled: false,
      editForm: {
        Name: '',
        Country: 'CN',
        Province: 'Beijing',
        Locality: 'Beijing',
        Addr: ''
      },
      editRules: {
        Name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        Country: [{ required: true, message: '请输入国家', trigger: 'blur' }],
        Province: [{ required: true, message: '请输入省份', trigger: 'blur' }],
        Locality: [{ required: true, message: '请输入地区', trigger: 'blur' }],
        Addr: [{ required: true, validator: validateAddr, trigger: 'blur' }],
        Username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          },
          {
            trigger: 'blur',
            validator: this.validateUsername
          }
        ],
        Password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            trigger: 'blur',
            validator: this.validatePassword
          }
        ]
      },
      adaptationVars: {
        formLabelWidth: 80
      }
    }
  },
  methods: {
    validateUsername(rule, value, callback) {
      const testResult = this.$utils.checkCertificateName(value)
      if (testResult) {
        this.$message.error(testResult)
      } else {
        callback()
      }
    },
    validatePassword(rule, value, callback) {
      const reg = /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/
      if (!reg.test(value)) {
        this.$message.error('请输入至少8位密码，必须同时包含字母、数字和特殊字符')
      } else {
        callback()
      }
    },
    handleCancel() {
      this.editForm = {
        Name: '',
        Country: 'CN',
        Province: 'Beijing',
        Locality: 'Beijing',
        Addr: ''
      }
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.dialogVisible = true
    },
    handleOk() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$apis.certificate.initRoot(this.editForm).then(res => {
            this.$message.success('添加CA服务成功！')
            this.$emit('update:list')
            this.handleCancel()
          })
        } else {
          this.$message.warning('请填写内容')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-ca-service-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
